/**
 * Plan price sync: URL ?selling_plan=ID or selling_plan input change
 * -> update Afterpay amount and optional [data-pdp-price] / [data-pdp-compare] hooks.
 * One-time selection uses the "one" map entry (compare-at SAVE badge data).
 */
(function () {
  if (window.__pdpPlanPriceSync) return;
  window.__pdpPlanPriceSync = true;

  function findMapEl() {
    return document.querySelector('[data-pdp-plan-map]');
  }

  function parseMap() {
    const mapEl = findMapEl();
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent);
    } catch (e) {
      console.warn('pdp plan map parse failed', e);
      return null;
    }
  }

  let MAP = parseMap();

  function currentPlanId() {
    const planInput = document.querySelector('[data-pdp-selling-plan]');
    if (planInput) return !planInput.disabled && planInput.value ? String(planInput.value) : null;
    const fromUrl = new URLSearchParams(window.location.search).get('selling_plan');
    if (fromUrl) return String(fromUrl);
    const checked = document.querySelector('input[name="selling_plan"]:checked');
    if (checked && checked.value) return String(checked.value);
    const sel = document.querySelector('select[name="selling_plan"]');
    if (sel && sel.value) return String(sel.value);
    return null;
  }

  function paintThemePrice(root, priceText, compareText, showCompare) {
    root.querySelectorAll('product-price').forEach((box) => {
      const regular = box.querySelector('.price__regular');
      const sale = box.querySelector('.price__sale');
      const saleEl = box.querySelector('.price-item--sale');
      const compareEl = box.querySelector('.price__sale .compare-at-price');
      const savings = box.querySelector('.price-item__savings');
      if (savings) savings.style.display = 'none';

      if (showCompare && sale && saleEl) {
        if (regular) regular.classList.add('price__hidden');
        sale.classList.remove('price__hidden');
        saleEl.textContent = priceText;
        // if (compareEl) {
        //   compareEl.textContent = compareText;
        //   compareEl.hidden = false;
        //   compareEl.style.setProperty('display', 'inline', 'important');
        // }
      } else if (regular) {
        if (sale) sale.classList.add('price__hidden');
        regular.classList.remove('price__hidden');
        const regularEl = regular.querySelector('.price');
        if (regularEl) regularEl.textContent = priceText;
        if (compareEl) compareEl.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function apply() {
    const mapEl = findMapEl();
    if (!MAP) {
      MAP = parseMap();
      if (!MAP) return;
    }

    const root = (mapEl && mapEl.closest('.shopify-section')) || document;
    const id = currentPlanId();
    const plan = id && MAP.plans ? MAP.plans[id] : null;
    const priceText = plan ? plan.price : MAP.one.price;
    const compareText = plan ? plan.compare : MAP.one.compare;
    const showCompare = plan ? plan.price !== plan.compare : !!MAP.one.hasCompare;

    root.querySelectorAll('[data-pdp-price]').forEach((headPrice) => {
      headPrice.textContent = priceText;
    });

    root.querySelectorAll('[data-pdp-compare]').forEach((headCompare) => {
      headCompare.textContent = compareText;
      headCompare.hidden = !showCompare;
    });

    paintThemePrice(root, priceText, compareText, showCompare);

    const amount = plan && plan.amount ? plan.amount : MAP.one.amount;
    if (amount) {
      root.querySelectorAll('[data-pdp-afterpay]').forEach((afterpay) => {
        afterpay.setAttribute('data-amount', amount);
      });
    }
  }

  ['pushState', 'replaceState'].forEach((fn) => {
    const orig = history[fn];
    history[fn] = function () {
      const out = orig.apply(this, arguments);
      window.dispatchEvent(new Event('pdp:urlchange'));
      return out;
    };
  });

  window.addEventListener('pdp:urlchange', apply);
  window.addEventListener('popstate', apply);

  document.addEventListener('change', (e) => {
    if (!e.target) return;
    const inWidget = e.target.closest && e.target.closest('subscription-widget');
    if (e.target.name === 'selling_plan' || e.target.hasAttribute?.('data-pdp-selling-plan') || inWidget) {
      setTimeout(apply, 50);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
